export default __webpack_public_path__ + "static/media/avatarDefault.01f2b26b.jpg";